import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const ResetPassword = () => {
 const location = useLocation();
 const url = process.env.REACT_APP_API_BASE_URL;

 const navigator = useNavigate();
 const [email, setEmail] = useState(location.state?.email || "");
 const [password, setPassword] = useState("");
 const [confirmPassword, setConfirmPassword] = useState("");
 const [submitAttempted, setSubmitAttempted] = useState(false);
 const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
 const [errors, setErrors] = useState({
  email: "",
  password: "",
  confirmPassword: "",
 });

 const handleChange = (e) => {
  const { name, value } = e.target;
  setErrors({ ...errors, [name]: "" });
  if (name === "email") {
   setEmail(value);
  } else if (name === "password") {
   setPassword(value);
  } else if (name === "confirmPassword") {
   setConfirmPassword(value);
  }
 };

 const togglePassword = () => {
  setShowPassword(!showPassword);
};

const toggleConfirmPassword = () => {
  setShowConfirmPassword(!showConfirmPassword);
};
 const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitAttempted(true);

  let errors = {};

  if (!email.trim()) {
   errors.email = "Email is required";
  }

  if (!password.trim()) {
   errors.password = "Password is required";
  }

  if (!confirmPassword.trim()) {
   errors.confirmPassword = "Confirm Password is required";
  } else if (password !== confirmPassword) {
   errors.confirmPassword = "Passwords don't match";
  }

  if (Object.keys(errors).length > 0) {
   setErrors(errors);
   return;
  }

  try {
   const response = await axios.post(`${url}api/auth/admin/reset-password`, {
    email,
    password,
    confirmPassword,
   });
   if (response.status === 200) {
    toast.success(response.data.message);
    navigator("/");
   } else {
    toast.error(response.data.message);
   }
  } catch (error) {
   if (error.response.data.message) {
    toast.error(error.response.data.message);
   } else {
    toast.error("Something went wrong. Please try again!!");
   }
  }
 };

 return (
  <>
   <div className="container-scroller">
    <div className="container-fluid page-body-wrapper full-page-wrapper">
     <div className="content-wrapper d-flex align-items-center auth">
      <div className="row flex-grow">
       <div className="col-lg-4 mx-auto">
        <div className="auth-form-light text-left p-5">
         <div className="brand-logo text-center">
          <img src="./logo.webp" alt="Logo_img" />
         </div>

         <form className="pt-3" onSubmit={handleSubmit}>
          <div className="form-group">
           <input
            type="email"
            className="form-control form-control-sm border border-dark   "
            id="email"
            name="email"
            placeholder="Email"
            value={email}
            readOnly
            onChange={handleChange}
           />
           {submitAttempted && errors.email && (
            <p className="text-danger">{errors.email}</p>
           )}
          </div>
          <div className="form-group">
  <div className="password-wrapper">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control form-control-sm border border-dark"
      name="password"
      placeholder="New Password"
      value={password}
      onChange={handleChange}
    />
    <span className="eye-icon" onClick={togglePassword}>
      <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
    </span>
  </div>

  {submitAttempted && errors.password && (
    <p className="text-danger">{errors.password}</p>
  )}
</div>
<div className="form-group">
  <div className="password-wrapper">
    <input
      type={showConfirmPassword ? "text" : "password"}
      className="form-control form-control-sm border border-dark"
      name="confirmPassword"
      placeholder="Confirm New Password"
      value={confirmPassword}
      onChange={handleChange}
    />
    <span className="eye-icon" onClick={toggleConfirmPassword}>
      <i className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`} />
    </span>
  </div>

  {submitAttempted && errors.confirmPassword && (
    <p className="text-danger">{errors.confirmPassword}</p>
  )}
</div>
          <div className="mt-3">
           <button
            type="submit"
            className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
           >
            Save
           </button>
          </div>
         </form>
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </>
 );
};

export default ResetPassword;
